import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/yoast': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M91.3 76H277.3L270.3 94.9H91.3C51.6 94.9 19.4 126.5 19.4 165.2V370.6C19.4 406 44.3 440.9 103.4 440.9V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zM320.4 20H386.9C243.1 398.1 241.2 418.9 202.2 459.3 181.4 480.9 152.9 491 123.9 492V440.9C173.1 433.2 188.5 391 188.5 365.6 188.5 345.5 189.1 353 106.4 142.4H167.8L218.2 299 320.4 20zM448 161.5V460H234C240.6 450.4 244.7 443.7 246.1 440.6H428.6V161.5C428.6 129 411.5 109.6 380.4 98.6L387.1 81C428.8 94.6 448 124.1 448 161.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/yoast.js
// module id = F8Dv
// module chunks = 144